import {
  callGetAccountsErrorToast,
  callGetProductsErrorToast,
  callGetTransferSetsErrorToast,
} from '@features/accounts/api';
import { callCobrandErrorToast } from '@features/navigation/api/get-cobrand';
import { callGetNotificationErrorToast } from '@features/navigation/api/get-notification';
import { callGetBanksErrorToast } from '@features/performance/api/get-banks';
import { callGetPerformanceDataErrorToast } from '@features/performance/api/get-performance-data';
import { callGetProfileErrorToast } from '@features/user/api';
import { ToastUtility } from '@utils';

export const toastNotificationSwitch = (queryKey: string) => {
  switch (queryKey) {
    case 'accounts':
      callGetAccountsErrorToast();
      break;
    case 'banks':
      callGetBanksErrorToast();
      break;
    case 'cobrand':
      callCobrandErrorToast();
      break;
    case 'performanceData':
      callGetPerformanceDataErrorToast();
      break;
    case 'products':
      callGetProductsErrorToast();
      break;
    case 'profile':
      callGetProfileErrorToast();
      break;
    case 'transferSets':
      callGetTransferSetsErrorToast();
      break;
    case 'notifications':
      callGetNotificationErrorToast();
      break;
    default:
      ToastUtility.error(
        'An error has occurred. Check console for more details.',
      );
      break;
  }
};
